import { render, staticRenderFns } from "./NumberHero.vue?vue&type=template&id=24364780&scoped=true"
import script from "./NumberHero.vue?vue&type=script&lang=js"
export * from "./NumberHero.vue?vue&type=script&lang=js"
import style0 from "./NumberHero.vue?vue&type=style&index=0&id=24364780&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24364780",
  null
  
)

export default component.exports